interface GetEmployeeNodeStatusArgs {
  employeeId: string
  filteredEmployeeIds?: Set<string>
  highlightedEmployeeId?: string
  search: string
  searchResultId?: string
}

export const getEmployeeNodeStatus = ({
  employeeId,
  filteredEmployeeIds,
  highlightedEmployeeId,
  search,
  searchResultId,
}: GetEmployeeNodeStatusArgs): 'dimmed' | 'highlighted' | undefined => {
  if (highlightedEmployeeId === employeeId) {
    return 'highlighted'
  }

  if (!search) {
    return undefined
  }

  if (searchResultId === employeeId) {
    return 'highlighted'
  }

  if (filteredEmployeeIds && !filteredEmployeeIds.has(employeeId)) {
    return 'dimmed'
  }

  return undefined
}
